import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  isSelected?: boolean;
  left?: boolean;
}

export const Root = styled.div`
`;

export const Command = styled.div`
  display: flex;
  font-family: Roboto;
  font-size: 23px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #cccccc;
  margin-top:7px;
  margin-right:8px;
  margin-left:2px;
  position: relative;
`;


export const Button = styled.div`
  display: inline-block;
  width: 26.5px;
  height: 29px;
  text-align: center;
  border-radius: ${(props: IRootProps) => props.left ? '5px 0px 0px 5px' : '0px 5px 5px 0px'};
  border: solid 0.5px ${C.GENERIC_GRAY};
  background-color: transparent;
  cursor: pointer;
  &:hover {
      background-color: ${C.GRAY}
    }
`;

export const SizesList = styled.div`
  width: 90px;
  height: auto;
  position: absolute;
  border-radius: 3px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  z-index: 51;
  margin-top: 5px; 
  margin-left: 28.5px;
  max-height: 540px;
  overflow-x: hidden;
  overflow-y: auto;
  &.list-enter {
      opacity: 0;
  }
  &.list-enter-active {
    opacity: 1;
    transition: opacity 500ms;
  }
  &.list-exit {
    opacity: 1;
  }
  &.list-exit-active {
      opacity: 0;
      transition: opacity 500ms;
  }
`;

export const Option = styled.div`
  width: auto;
  height: 20px;
  flex-grow: 0;
  background-color: ${(props: IRootProps) => props.isSelected? 'rgba(18, 36, 66, 0.05)':'#ffffff'};
  padding: 7.5px 16px;
  font-size: 16px;
  font-weight: 500;
  color: #272727;
  cursor:pointer;
  &:hover{
    background-color: rgba(18, 36, 66, 0.05);
  }
`;